"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var __1 = require("../..");
var FunctionOrNode_1 = require("../FunctionOrNode");
exports.WithViewEditPermissionList = function (_a) {
    var viewConfig = _a.view, editConfig = _a.edit, fallback = _a.fallback;
    return (React.createElement(__1.IdentityConsumer, null, function (_a) {
        var roles = _a.roles;
        if (roles && roles.some(function (role) { return editConfig.permission.includes(role); })) {
            return React.createElement(FunctionOrNode_1.FunctionOrNode, null, editConfig.component);
        }
        if (roles && roles.some(function (role) { return viewConfig.permission.includes(role); })) {
            return React.createElement(FunctionOrNode_1.FunctionOrNode, null, viewConfig.component);
        }
        return Boolean(fallback) ? (React.createElement(FunctionOrNode_1.FunctionOrNode, null, fallback)) : null;
    }));
};
exports.WithViewEditPermissionList.displayName = 'WithViewEditPermissionList';
